export function yupTransformNumeric(_, value) {
  if (typeof value === 'string') {
    return +value?.replace(/,/g, '');
  }

  return value;
}
